export const SCRUB_VIEW_TYPE = {
    scrub_missing: {
        title: "missing_title",
        button: "mark_as_missing",
        targetUseCase: "MISSING",
        tableHeader: "packages_shipped_missing",
        review_button: "review_missing",
        show_mnr: "show_mnr",
        view_name: "scrub_missing"
    },
    scrub_lost: {
        title: "lost_title",
        button: "mark_as_lost",
        targetUseCase: "LOST",
        tableHeader: "packages_shipped_lost",
        review_button: "review_lost",
        view_name: "scrub_lost"
    }
};

export const SCRUB_BUTTON_TYPE = {
    invoke_in_station_scrub: {
        button: "in_station_scrub",
        scrubType: "IN_STATION"
    },
    invoke_on_road_scrub: {
        button: "on_road_scrub",
        scrubType: "ON_ROAD"
    }
};

export const SCRUB_INVOCATION_LIST_HEADERS = ["STATION","OPERATION_PERSON","LAST_UPDATED"];

export const SCRUB_INVOCATION_LIST_HEADERS_CSV = {
    invoke_in_station_scrub: [
        ["STATION", {stringId: "scrub_station_code"}],
        ["OPERATION_PERSON", {stringId: "operation_person"}],
        ["LAST_UPDATED", {stringId: "last_updated_on"}]],
    invoke_on_road_scrub: [
        ["STATION", {stringId: "station"}],
        ["OPERATION_PERSON", {stringId: "operation_person"}],
        ["LAST_UPDATED", {stringId: "last_updated"}]]
};

export const TARGET_USE_CASES = ["MISSING", "LOST"];

export const SCRUB_LIST_HEADERS = {
    scrub_missing: [
        ["TRACKING_NUMBER", {stringId: "tracking_number"}],
        ["STATUS", {stringId: "status"}],
        ["REASON", {stringId: "reason"}],
        ["LAST_UPDATED", {stringId: "last_updated"}],
        ["STATION", {stringId: "station"}],
        ["SORT_ZONE", {stringId: "sort_zone"}],
        ["ROUTE", {stringId: "route"}]],
    scrub_lost: [
        ["TRACKING_NUMBER", {stringId: "tracking_number"}],
        ["STATUS", {stringId: "status"}],
        ["REASON", {stringId: "reason"}],
        ["LAST_UPDATED", {stringId: "last_updated"}],
        ["STATION", {stringId: "station"}],
        ["SORT_ZONE", {stringId: "sort_zone"}]]
};

export const SCRUB_EXCEPTION_CATEGORIES = [
    "STATION_SWEEP",
    "STATION_SWEEP_ON_ROAD_WITH_DA",
    "SCRUB_HFCR_CANCELLED",
    "SCRUB_HFCR_REDIRECT",
    "SCRUB_HFCR_RESCHEDULE"
];

export const SCRUB_EXCEPTION_CATEGORIES_ON_ROAD = [
    "STATION_SWEEP_ON_ROAD_WITH_DA"
];

export const OUT_ON_ROAD_STATUS_LIST = [
  "IN_TRANSIT",
  "DELIVERY_FAILED",
  "DROPPED",
  "DROP_FAILED",
  "DELIVERY_REJECTED",
  "DELAYED",
  "ON_ROAD_WITH_DELIVERY_ASSOCIATE",
  "DELIVERY_ATTEMPTED",
  "NOT_ATTEMPTED"
];

export const SCRUB_PAGE_SIZE = 50;
export const BUTTON_DISABLE_TIME  = 600000;
export const REMOVE_MISSING_BUTTON_DISABLE_TIME  = 300000;
export const BUTTON_DISABLE_KEY_PREFIX = 'button.disable';
export const STATION_CODE = 'scrub.trigger.stationCode';
export const STATION_CODE_SCRUB_UPDATE = 'scrub.update.stationCode';
export const REMOVE_MISSING_BUTTON_DISABLE_KEY_PREFIX = 'remove.missing.button.disable';
export const SCRUB_LIST_IDENTIFIER = "TRACKING_NUMBER";
export const SCRUB_CSV_DATE_FORMAT = 'yyyy-MM-dd';
export const PACKAGE_COUNT_WARNING_THRESHOLD = 300;
export const SCRUB_EXCEPTION_START_RANGE_DAYS = 10;
export const SCRUB_EXCEPTION_START_RANGE_DAYS_IN = 14;
export const SCRUB_EXCEPTION_END_RANGE_DAYS = 0;
export const SCRUB_EXCEPTION_END_RANGE_DAYS_IN = 5;
export const SCRUB_EXCEPTION_END_RANGE_DAYS_LOST = 3;
export const SCRUB_EXCEPTION_START_RANGE_DAYS_LOST = 14;
export const IS_LOST_TAB_ENABLED = 'IS_LOST_TAB_ENABLED';
export const MISSING_VIEW_NEW_STRATEGY_FEATURE_NAME = "MISSING_VIEW_NEW";
export const SELECTIVE_MARKING_ENABLED = "SELECTIVE_MARKING_ENABLED";
export const LOST_QUEUE_SLA = "AUTOMATIC_SELECTION_SLA_FOR_LOST_QUEUE";
export const TERMINAL_SCAN_BREACHED_RESPONSE = "TERMINAL_SCAN_UPDATE_SLA_BREACHED";
export const REMOVE_MISSING_DELIVERED_SCAN_ENABLED = "REMOVE_MISSING_DELIVERED_SCAN_ENABLED";
export const TERMINAL_SCAN_AGEING_MISSING_QUEUE_ENABLED = "TerminalScanRequestAgeingSLAForMissingQueueEnabled";
export const MISSING_QUEUE_SLA = "TERMINAL_SCAN_REQUEST_AGEING_SLA_FOR_MISSING_QUEUE";
export const SCRUB_MARK_AS_LOST_SELECTION_METRIC = "SCRUB_MARK_AS_LOST_SELECTION";
export const METADATA_TICKET_ID = "TICKET_ID";
export const METADATA_TERMINAL_SCAN = "TERMINAL_SCAN";
export const UNAUTHORISED_USER = "unauthorised_user";
export const UNAUTHORISED_USER_IDENTIFIED = "UNAUTHORISED_USER";
export const IS_ENABLED_INTERNAL_ESTIMATED_ARRIVAL_DATE_SCRUB_RULE_FOR_LOST = "IS_ENABLED_INTERNAL_ESTIMATED_ARRIVAL_DATE_SCRUB_RULE_FOR_LOST";
export const GET_SCRUB_SHIPMENTS_DETAILS_IN_BATCHES_DATA = "GET_SCRUB_SHIPMENTS_DETAILS_IN_BATCHES_DATA";
export const GET_SCRUB_SHIPMENTS_DETAILS_CHUNK_SIZE_DEFAULT_VALUE = 500;




// WEBPACK FOOTER //
// ./src/commons/constants/ScrubConstants.js